<template>
  <div align-center justify-center style="font-family: 'Kanit', sans-serif" class="mb-12">
    <v-row no-gutters class="">
      <v-col cols="1" md="1" xs="1" sm="1"></v-col>
      <v-col cols="10" md="11" xs="10" sm="10">
        <v-row no-gutters class="pt-16">
          <v-col cols="12" md="6" xs="12" sm="12">
            <!-- <v-img src="@/assets/Image.png"></v-img> -->
            <v-col cols="1" md="1" xs="1" sm="1"></v-col>
            <div class="video-lobby">
              <video id="vid" width="100%" height="100%" style="border-radius: 20px;"
                :muted="!showHeart || micVolume === 0" :class="{ 'video-muted': !clickvideo }">
                Your browser does not support the video tag.
              </video>
              <div v-if="cameraLoading" class="video-loading-overlay">
                <v-progress-circular indeterminate color="white" size="48" />
                <span class="video-loading-text">{{ $t("message.loadingCamera") }}</span>
              </div>
              <div v-else-if="cameraBlocked" class="video-permission-overlay">
                <v-icon class="video-permission-icon" color="white">mdi-video-off-outline</v-icon>
                <span class="video-permission-text">{{ $t("message.cameraBlocked") }}</span>
              </div>
              <div v-else-if="!clickvideo" class="video-off-overlay">
                <v-icon class="video-off-icon" color="white">mdi-video-off</v-icon>
                <span class="video-off-text">{{ $t("message.cameraOff") }}</span>
              </div>
              <div class="video-button" v-if="!cameraLoading && !cameraBlocked && !loading">
                <v-btn depressed fab class="video-action-btn" @click="closeAudio">
                  <v-icon v-if="!clickvoice">mdi-microphone-off</v-icon>
                  <v-icon v-else>mdi-microphone</v-icon>
                </v-btn>
                <v-btn depressed fab class="video-action-btn" @click="closeVideo">
                  <v-icon v-if="!clickvideo">mdi-video-off</v-icon>
                  <v-icon v-else>mdi-video</v-icon>
                </v-btn>
                <v-menu v-if="$vuetify.breakpoint.width > 500" v-model="audioMenu" offset-y
                  transition="scale-transition" :close-on-content-click="false" min-width="260">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed fab class="video-action-btn" v-bind="attrs" v-on="on">
                      <v-icon>mdi-microphone-settings</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="device-dropdown-card">
                    <div class="device-dropdown-header">
                      <v-icon small color="#5865F2" class="mr-2">mdi-microphone-settings</v-icon>
                      <span>{{ $t('message.micSelect') }}</span>
                    </div>
                    <v-divider />
                    <v-list dense class="device-dropdown-list">
                      <v-list-item v-for="option in selectAudioDevices" :key="option" @click="selectAudioDevice(option)"
                        :class="{ 'is-active': audioDevices === option }">
                        <v-list-item-icon>
                          <v-icon v-if="audioDevices === option" color="#5865F2">mdi-check</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ option }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="!selectAudioDevices.length" disabled>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{
                              $t('message.noDevices') !== 'message.noDevices'
                                ? $t('message.noDevices')
                                : 'No devices found'
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
                <v-menu v-if="$vuetify.breakpoint.width > 500" v-model="videoMenu" offset-y
                  transition="scale-transition" :close-on-content-click="false" min-width="260">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed fab class="video-action-btn" v-bind="attrs" v-on="on">
                      <v-icon>mdi-video-switch</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="device-dropdown-card">
                    <div class="device-dropdown-header">
                      <v-icon small color="#5865F2" class="mr-2">mdi-video-outline</v-icon>
                      <span>{{ $t('message.camSelect') }}</span>
                    </div>
                    <v-divider />
                    <v-list dense class="device-dropdown-list">
                      <v-list-item v-for="option in selectVideoDevices" :key="option" @click="selectVideoDevice(option)"
                        :class="{ 'is-active': videoDevices === option }">
                        <v-list-item-icon>
                          <v-icon v-if="videoDevices === option" color="#5865F2">mdi-check</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ option }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="!selectVideoDevices.length" disabled>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{
                              $t('message.noDevices') !== 'message.noDevices'
                                ? $t('message.noDevices')
                                : 'No devices found'
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
                <!-- Test Mic -->
                <!-- <v-menu v-if="$vuetify.breakpoint.width > 500" v-model="micTestMenu" offset-y
                  transition="scale-transition" :close-on-content-click="false" min-width="320">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed fab class="video-action-btn" v-bind="attrs" v-on="on">
                      <v-icon>mdi-microphone-check</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="mic-test-dropdown-card">
                    <div class="mic-test-dropdown-header">
                      <v-icon small color="#5865F2" class="mr-2">mdi-microphone-check</v-icon>
                      <div>
                        <div class="mic-test-dropdown-title">{{ $t('message.checkMic') }}</div>
                      </div>
                    </div>
                    <v-divider class="my-3" />
                    <div class="mic-test-dropdown-body">
                      <div class="mic-volume-column">
                        <span class="mic-volume-value">{{ micVolume }}</span>
                        <v-slider v-model="micVolume" class="mic-volume-slider" min="0" max="200" step="1"
                          color="#5865F2" track-color="#2c2f3b" thumb-label @input="onMicVolumeChange"></v-slider>
                        <span class="mic-volume-label">{{ micVolumeLabel }}</span>
                      </div>
                      <div class="mic-visualizer mic-visualizer-popup"
                        :class="{ 'is-active': microphoneCheckActive || showHeart }">
                        <div v-if="showHeart" class="mic-visualizer-live">
                          <audio ref="player"></audio>
                          <av-media class="av-media-style" type="frequ" :media="media" :line-width="2"
                            line-color="#5865F2" :canv-width="micCanvasWidth" :bar-length="3" :line-space="2" />
                        </div>
                        <div v-else class="mic-visualizer-idle">
                          <span v-for="bar in micLevelBars" :key="bar" class="mic-visualizer-idle-bar"
                            :style="micBarStyle(bar)"></span>
                        </div>
                      </div>
                    </div>
                    <div class="mic-test-dropdown-actions">
                      <v-btn block class="mic-test-button" :class="{ 'is-active': showHeart }" color="#5865F2" dark
                        rounded depressed :loading="microphoneCheckActive" :disabled="microphoneCheckActive" height="44"
                        @click="checkMicrophone">
                        <v-icon left small>mdi-microphone-check</v-icon>
                        {{ $t('message.checkMic') }}
                      </v-btn>
                    </div>
                  </v-card>
                </v-menu> -->
              </div>
            </div>
            <div class="toggle-switch-wrapper">
              <label class="toggle-switch">
                <input type="checkbox" v-model="switchEnabled">
                <span class="toggle-track">
                  <span class="toggle-label-on">ON</span>
                  <span class="toggle-label-off">OFF</span>
                  <span class="toggle-thumb"></span>
                </span>
              </label>
              <span class="toggle-text-label" :class="{ 'is-on': switchEnabled }">
                {{ switchEnabled ? 'เปิดพื้นหลังที่ใช้ล่าสุด' : 'ปิดพื้นหลังที่ใช้ล่าสุด' }}
              </span>
            </div>
          </v-col>
          <!-- <v-col md="1"></v-col> -->
          <v-col cols="12" md="6" xs="12" sm="12" class="pb-6 pl-12" align-self="center"
            v-if="($vuetify.breakpoint.lg || $vuetify.breakpoint.md || $vuetify.breakpoint.xl || $vuetify.breakpoint.xxl || $vuetify.breakpoint.sm)">
            <v-row no-gutters class="ml-2 mb-4" v-if="namecompany !== ''">
              <v-col cols="2" md="2" sm="2" xs="2" class="mr-6" style="cursor: pointer;" @click="gomanage()">
                <v-img :src="logo" max-width="90px" max-height="100px"></v-img>
              </v-col>
              <v-col cols="8" md="6" sm="9" xs="8" align-self="center">
                <v-row>
                  <span style="
                      font-family: 'Noto Sans';
                      font-size: 24px;
                      font-weight: 550;
                      color: #353535;
                    ">{{ namecompany }}</span>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters class="ml-2 mb-4" v-if="namecompany === ''">
              <v-col cols="1" md="1" sm="1" xs="3"></v-col>
              <v-col cols="8" md="8" sm="8" xs="8" class="mr-6">
                <v-img :src="logo" max-width="150px" max-height="150px"></v-img>
              </v-col>
            </v-row>
            <div style="
                font-family: 'Kanit';
                font-size: 28px;
                font-weight: 1000;
                line-height: 55.46px;
                letter-spacing: -1.7%;
              " class="mt-1">
              {{ $t("message.readymeeting") }}
            </div>
            <div style="
                font-family: 'Kanit';
                font-size: 20px;
                font-weight: 600;
                color: #faad14;
              " class="pb-2">
              <span>{{ $t("roomsetting.roomname") }} : </span>
              <span>{{ roomname }}</span>
            </div>
            <div style="
                font-family: 'Kanit';
                font-size: 20px;
                font-weight: 600;
                color: #faad14;
              ">
              <span>{{ $t("roomsetting.typeroom") }} : </span>
              <span v-if="chkSecretRoom === true">{{ $t("roomsetting.secretmeeting") }}</span>
              <span v-if="chkSecretRoom === false">{{ $t("roomsetting.normalmeeting") }}</span>
            </div>
            <!-- <div
              v-if="userData.loa !== ''"
              style="
                font-family: 'Kanit';
                font-size: 20px;
                font-weight: 600;
                color: #faad14;
              "
            >
              <span>ระดับLOAของผู้เข้าร่วมการประชุม : </span>
              <span>{{ userData.loa }}</span>
            </div> -->
            <div class="mt-3">
              <v-row no-gutters>
                <v-col cols="12" md="2" sm="12" xs="12" align-self="center" class="mt-n4"
                  style="font-family: 'Kanit'; font-weight: 600">
                  <span>{{ $t("roomsetting.linkmeeting") }} : </span>
                </v-col>
                <v-col cols="7" md="5" sm="6" xs="7" align-self="center" class=""
                  style="font-family: 'Kanit'; font-weight: 600">
                  <v-text-field solo dense readonly background-color="#EDEDED" v-model="cid"></v-text-field>
                </v-col>
                <v-col cols="1" md="1" xs="1" sm="1" class="pl-2 mr-12">
                  <v-btn id="menu-activator" color="#3D85C6" outlined>
                    <v-icon dark> mdi-content-copy </v-icon>
                  </v-btn>
                  <v-menu activator="#menu-activator">
                    <v-list>
                      <v-list-item @click="copylink">
                        <v-list-item-title>{{ $t("roomsetting.copylink") }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="copylinkinfo">
                        <v-list-item-title>{{ $t("roomsetting.copyinfo") }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <!-- <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="#3D85C6" block @click="copylink" outlined v-bind="attrs" v-on="on">
                        <v-icon dark> mdi-content-copy </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("loginpage.coppy") }}{{ $t("roomsetting.linkmeeting") }}</span>
                  </v-tooltip> -->
                  <!-- <v-btn outlined block @click="copylink" color="#0B3A8F">
                    <v-icon dark> mdi-content-copy </v-icon></v-btn
                  > -->
                </v-col>
                <v-col cols="1" md="1" xs="1" sm="1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-on="on" v-bind="attrs" @click="dialogU = true" outlined block color="#3D85C6">
                        <v-icon dark> mdi-qrcode-scan </v-icon></v-btn>
                    </template>
                    <span>{{ $t("loginpage.qrcode") }}</span>
                  </v-tooltip>
                  <div class="text-center">
                    <v-dialog v-model="dialogU" width="230">
                      <v-card>
                        <v-icon @click="dialogU = false" class="mt-2" right>mdi-close-thick</v-icon>
                        <v-divider></v-divider>
                        <v-card-text class="pt-12">
                          <img :src="`data:image/png;base64,${qrcode}`" />
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" text @click="download()">
                            <v-icon color="#3D85C6" class="pl-2">mdi-tray-arrow-down</v-icon>{{ $t("button.download") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </div>
                </v-col>
                <input type="hidden" v-model="txtLink" id="txtLink" ref="txtLink" />
                <input type="hidden" v-model="txtinfo" id="txtinfo" ref="txtinfo" />
                <v-col cols="1" md="1" xs="1" sm="1">
                  <!-- <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-on="on" v-bind="attrs" @click="dialogU = true" outlined block color="#0B3A8F">
                    <v-icon dark> mdi-qrcode-scan </v-icon></v-btn>
                    </template>
                    <span>{{$t("loginpage.qrcode") }}</span>
                  </v-tooltip> -->
                  <div class="text-center">
                    <v-dialog v-model="dialogU" width="230">
                      <!-- <template v-slot:activator="{ on, attrs }">
                      <v-btn v-on="on" v-bind="attrs" outlined block color="#0B3A8F">
                    <v-icon dark> mdi-qrcode-scan </v-icon></v-btn>
                    </template> -->
                      <v-card>
                        <v-icon @click="dialogU = false" class="mt-2" right>mdi-close-thick</v-icon>
                        <v-divider></v-divider>
                        <v-card-text class="pt-12">
                          <img :src="`data:image/png;base64,${qrcode}`" />
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" text @click="download()">
                            <v-icon color="#3D85C6" class="pl-2">mdi-tray-arrow-down</v-icon>{{ $t("button.download") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </div>
                </v-col>
                <input type="hidden" v-model="txtLink" id="txtLink" ref="txtLink" />
                <input type="hidden" v-model="txtinfo" id="txtinfo" ref="txtinfo" />
              </v-row>
            </div>
            <div class="mt-n2">
              <v-row no-gutters>
                <v-col cols="12" md="2" sm="12" xs="12" align-self="center" class="mt-n4"
                  style="font-family: 'Kanit'; font-weight: 600">
                  <span>{{ $t("roomsetting.idrooms") }} : </span>
                </v-col>
                <v-col cols="8" md="6" sm="8" xs="10" align-self="center" class=""
                  style="font-family: 'Kanit'; font-weight: 600">
                  <v-text-field solo dense readonly background-color="#EDEDED" v-model="idrooms"></v-text-field>
                </v-col>
                <v-col cols="1" md="1" xs="1" sm="1" class="pl-2 mr-12">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="#3D85C6" block @click="copylinkidrroms" outlined v-bind="attrs" v-on="on">
                        <v-icon dark> mdi-content-copy </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("loginpage.coppy") }}{{ $t("roomsetting.idrooms") }}</span>
                  </v-tooltip>
                  <!-- <v-btn outlined block @click="copylinkidrroms" color="#0B3A8F">
                    <v-icon dark> mdi-content-copy </v-icon></v-btn
                  > -->
                </v-col>
                <input type="hidden" v-model="txtLinkidrooms" id="txtLinkidrooms" ref="txtLinkidrooms" />
              </v-row>
            </div>
            <v-row no-gutters v-if="this.password !== ''">
              <v-col cols="12" md="2" sm="12" xs="12" align-self="center" class="mt-n4">
                <span>{{ $t("roomsetting.pass") }} : </span>
              </v-col>
              <v-col cols="10" md="6" sm="10" xs="10" align-self="center" class="">
                <v-text-field v-model="password" solo dense readonly background-color="#EDEDED"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"></v-text-field>
              </v-col>
              <v-col cols="1" md="1" xs="1" sm="1" class="pl-2">
                <v-btn outlined block @click="copypass" color="#3D85C6">
                  <v-icon dark> mdi-content-copy </v-icon></v-btn>
              </v-col>
              <input type="hidden" v-model="txtpass" id="txtpass" ref="txtpass" />
            </v-row>
            <!-- <v-row no-gutters>
              <v-col
                cols="12"
                md="2"
                sm="12"
                xs="12"
                align-self="center"
                class="mt-n4"
              >
                <span>{{$t("roomsetting.videoquality") }} : </span>
              </v-col>
              <v-col
                cols="8"
                md="8"
                sm="12"
                xs="12"
                align-self="center"
                class="mt-2"
              >
                <v-select
                  :items="itemsvideo"
                  v-model="datavideo"
                  placeholder="Up to 2464kbps"
                  solo
                  dense
                  background-color="#EDEDED"
                ></v-select>
              </v-col>
            </v-row> -->
            <div class="mt-n4">
              <v-row no-gutters class="pl-9 pt-1">
                <v-col cols="12" md="12" sm="12" xs="12" align-self="center" class="ml-n8"
                  style="font-family: 'Kanit'; font-weight: 600">
                  <span style="font-size: 13.8px; color: #737373">*{{ $t("message.messageshare") }}</span>
                </v-col>
              </v-row>
            </div>
            <v-row class="mt-6">
              <v-col cols="10" md="10" sm="12" xs="12">
                <v-btn rounded block style="color: white" color="#3D85C6" @click="checktypestart" dark>
                  <v-icon class="pr-1">mdi-logout-variant</v-icon>
                  {{ $t("managepage.backrooms") }}
                </v-btn>
              </v-col>
              <v-col cols="10" md="10" sm="12" xs="12">
                <template>
                  <v-menu v-if="disconnect === true">
                    <template v-slot:activator="{ on: menu, attrs }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                          <v-btn rounded block color="#D5D8DC" v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                            <v-icon class="pr-1">mdi-archive-arrow-down-outline</v-icon>
                            {{ $t("button.btncloserooms") }}
                          </v-btn>
                        </template>
                        <span>{{ $t("message.canotclose") }}</span>
                      </v-tooltip>
                    </template>
                  </v-menu>
                  <v-btn v-if="disconnect === false" rounded block :loading="loading" :disabled="loading" color="error"
                    @click="endMeeting">
                    <v-icon class="pr-1">mdi-archive-arrow-down-outline</v-icon>
                    {{ $t("button.btncloserooms") }}
                    <template v-slot:loader>
                      <span>Loading...</span>
                    </template>
                  </v-btn>
                </template>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" xs="12" sm="12" class="pb-6 pl-12" align-self="center"
            v-if="($vuetify.breakpoint.xs)">
            <v-row no-gutters class="ml-2 mb-4" v-if="namecompany !== ''">
              <v-col cols="2" md="2" sm="2" xs="2" class="mr-6" style="cursor: pointer;" @click="gomanage()">
                <v-img :src="logo" max-width="90px" max-height="100px"></v-img>
              </v-col>
              <v-col cols="8" md="6" sm="9" xs="8" align-self="center">
                <v-row>
                  <span style="
                      font-family: 'Noto Sans';
                      font-size: 24px;
                      font-weight: 550;
                      color: #353535;
                    ">{{ namecompany }}</span>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters class="ml-2 mb-4" v-if="namecompany === ''">
              <v-col cols="1" md="1" sm="1" xs="1"></v-col>
              <v-col cols="5" md="5" sm="5" xs="5" class="mr-6">
                <v-img :src="logo" max-width="150px" max-height="150px"></v-img>
              </v-col>
            </v-row>
            <div style="
                font-family: 'Kanit';
                font-size: 28px;
                font-weight: 1000;
                line-height: 55.46px;
                letter-spacing: -1.7%;
              " class="mt-1">
              {{ $t("message.readymeeting") }}
            </div>
            <div style="
                font-family: 'Kanit';
                font-size: 20px;
                font-weight: 600;
                color: #faad14;
              " class="pb-2">
              <span>{{ $t("roomsetting.roomname") }} : </span>
              <span>{{ roomname }}</span>
            </div>
            <div style="
                font-family: 'Kanit';
                font-size: 20px;
                font-weight: 600;
                color: #faad14;
              ">
              <span>{{ $t("roomsetting.typeroom") }} : </span>
              <span v-if="chkSecretRoom === true">{{ $t("roomsetting.secretmeeting") }}</span>
              <span v-if="chkSecretRoom === false">{{ $t("roomsetting.normalmeeting") }}</span>
            </div>
            <!-- <div
              v-if="userData.loa !== ''"
              style="
                font-family: 'Kanit';
                font-size: 20px;
                font-weight: 600;
                color: #faad14;
              "
            >
              <span>ระดับLOAของผู้เข้าร่วมการประชุม : </span>
              <span>{{ userData.loa }}</span>
            </div> -->
            <div class="mt-3">
              <v-row no-gutters>
                <v-col cols="12" md="2" sm="12" xs="12" align-self="center" class="mt-n4"
                  style="font-family: 'Kanit'; font-weight: 600">
                  <span>{{ $t("roomsetting.linkmeeting") }} : </span>
                </v-col>
                <v-col cols="7" md="5" sm="6" xs="7" align-self="center" class=""
                  style="font-family: 'Kanit'; font-weight: 600">
                  <v-text-field solo dense readonly background-color="#EDEDED" v-model="cid"></v-text-field>
                </v-col>
                <v-col cols="1" md="1" xs="1" sm="1" class="pl-2 mr-12">
                  <v-btn id="menu-activator" color="#3D85C6" outlined>
                    <v-icon dark> mdi-content-copy </v-icon>
                  </v-btn>
                  <v-menu activator="#menu-activator">
                    <v-list>
                      <v-list-item @click="copylink">
                        <v-list-item-title>{{ $t("roomsetting.copylink") }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="copylinkinfo">
                        <v-list-item-title>{{ $t("roomsetting.copyinfo") }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <!-- <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="#0B3A8F" block @click="copylink" outlined v-bind="attrs" v-on="on">
                        <v-icon dark> mdi-content-copy </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("loginpage.coppy") }}{{ $t("roomsetting.linkmeeting") }}</span>
                  </v-tooltip> -->
                  <!-- <v-btn outlined block @click="copylink" color="#0B3A8F">
                    <v-icon dark> mdi-content-copy </v-icon></v-btn
                  > -->
                </v-col>
                <v-col cols="1" md="1" xs="1" sm="1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-on="on" v-bind="attrs" @click="dialogU = true" outlined block color="#0B3A8F">
                        <v-icon dark> mdi-qrcode-scan </v-icon></v-btn>
                    </template>
                    <span>{{ $t("loginpage.qrcode") }}</span>
                  </v-tooltip>
                  <div class="text-center">
                    <v-dialog v-model="dialogU" width="230">
                      <v-card>
                        <v-icon @click="dialogU = false" class="mt-2" right>mdi-close-thick</v-icon>
                        <v-divider></v-divider>
                        <v-card-text class="pt-12">
                          <img :src="`data:image/png;base64,${qrcode}`" />
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" text @click="download()">
                            <v-icon color="#0B3A8F" class="pl-2">mdi-tray-arrow-down</v-icon>{{ $t("button.download") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </div>
                </v-col>
                <input type="hidden" v-model="txtLink" id="txtLink" ref="txtLink" />
                <input type="hidden" v-model="txtinfo" id="txtinfo" ref="txtinfo" />
                <!-- <v-col cols="1" md="1" xs="1" sm="1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-on="on" v-bind="attrs" @click="dialogU = true" outlined block color="#0B3A8F">
                    <v-icon dark> mdi-qrcode-scan </v-icon></v-btn>
                    </template>
                    <span>{{$t("loginpage.qrcode") }}</span>
                  </v-tooltip>
                  <div class="text-center">
                  <v-dialog
                    v-model="dialogU"
                    width="230">
                    <v-card>
                      <v-icon @click="dialogU = false" class="mt-2" right>mdi-close-thick</v-icon>
                      <v-divider></v-divider>
                      <v-card-text  class="pt-12">
                        <img  :src="`data:image/png;base64,${qrcode}`" />
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          text
                          @click="download()"
                        >
                        <v-icon color="#0355CB" class="pl-2">mdi-tray-arrow-down</v-icon>{{ $t("button.download") }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
                </v-col> -->
                <input type="hidden" v-model="txtLink" id="txtLink" ref="txtLink" />
                <input type="hidden" v-model="txtinfo" id="txtinfo" ref="txtinfo" />
              </v-row>
            </div>
            <div class="mt-n2">
              <v-row no-gutters>
                <v-col cols="12" md="2" sm="12" xs="12" align-self="center" class="mt-n4"
                  style="font-family: 'Kanit'; font-weight: 600">
                  <span>{{ $t("roomsetting.idrooms") }} : </span>
                </v-col>
                <v-col cols="8" md="6" sm="8" xs="10" align-self="center" class=""
                  style="font-family: 'Kanit'; font-weight: 600">
                  <v-text-field solo dense readonly background-color="#EDEDED" v-model="idrooms"></v-text-field>
                </v-col>
                <v-col cols="1" md="1" xs="1" sm="1" class="pl-2 mr-12">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="#0B3A8F" block @click="copylinkidrroms" outlined v-bind="attrs" v-on="on">
                        <v-icon dark> mdi-content-copy </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("loginpage.coppy") }}{{ $t("roomsetting.idrooms") }}</span>
                  </v-tooltip>
                  <!-- <v-btn outlined block @click="copylinkidrroms" color="#0B3A8F">
                    <v-icon dark> mdi-content-copy </v-icon></v-btn
                  > -->
                </v-col>
                <input type="hidden" v-model="txtLinkidrooms" id="txtLinkidrooms" ref="txtLinkidrooms" />
              </v-row>
            </div>
            <v-row no-gutters v-if="this.password !== ''">
              <v-col cols="12" md="2" sm="12" xs="12" align-self="center" class="mt-n4">
                <span>{{ $t("roomsetting.pass") }} : </span>
              </v-col>
              <v-col cols="10" md="6" sm="10" xs="10" align-self="center" class="">
                <v-text-field v-model="password" solo dense readonly background-color="#EDEDED"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"></v-text-field>
              </v-col>
              <v-col cols="1" md="1" xs="1" sm="1" class="pl-2">
                <v-btn outlined block @click="copypass" color="#0B3A8F">
                  <v-icon dark> mdi-content-copy </v-icon></v-btn>
              </v-col>
              <input type="hidden" v-model="txtpass" id="txtpass" ref="txtpass" />
            </v-row>
            <!-- <v-row no-gutters>
              <v-col
                cols="12"
                md="2"
                sm="12"
                xs="12"
                align-self="center"
                class="mt-n4"
              >
                <span>{{$t("roomsetting.videoquality") }} : </span>
              </v-col>
              <v-col
                cols="8"
                md="8"
                sm="12"
                xs="12"
                align-self="center"
                class="mt-2"
              >
                <v-select
                  :items="itemsvideo"
                  v-model="datavideo"
                  placeholder="Up to 2464kbps"
                  solo
                  dense
                  background-color="#EDEDED"
                ></v-select>
              </v-col>
            </v-row> -->
            <div class="mt-n4">
              <v-row no-gutters class="pl-9 pt-1">
                <v-col cols="12" md="12" sm="12" xs="12" align-self="center" class="ml-n8"
                  style="font-family: 'Kanit'; font-weight: 600">
                  <span style="font-size: 13.8px; color: #737373">*{{ $t("message.messageshare") }}</span>
                </v-col>
              </v-row>
            </div>
            <v-row class="mt-6">
              <v-col cols="10" md="10" sm="12" xs="12">
                <v-btn rounded block color="primary" @click="checktypestart" dark>
                  <v-icon class="pr-1">mdi-logout-variant</v-icon>
                  {{ $t("managepage.backrooms") }}
                </v-btn>
              </v-col>
              <v-col cols="10" md="10" sm="12" xs="12">
                <template>
                  <v-menu v-if="disconnect === true">
                    <template v-slot:activator="{ on: menu, attrs }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                          <v-btn rounded block color="#D5D8DC" v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                            <v-icon class="pr-1">mdi-archive-arrow-down-outline</v-icon>
                            {{ $t("button.btncloserooms") }}
                          </v-btn>
                        </template>
                        <span>{{ $t("message.canotclose") }}</span>
                      </v-tooltip>
                    </template>
                  </v-menu>
                  <v-btn v-if="disconnect === false" rounded block :loading="loading" :disabled="loading" color="error"
                    @click="endMeeting">
                    <v-icon class="pr-1">mdi-archive-arrow-down-outline</v-icon>
                    {{ $t("button.btncloserooms") }}
                    <template v-slot:loader>
                      <span>Loading...</span>
                    </template>
                  </v-btn>
                </template>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <!-- <v-col cols="1" md="1" xs="1" sm="1"></v-col> -->
    </v-row>
    <!-- Dialog Device -->
    <v-dialog v-model="setDialogDevice" width="600px">
      <v-card>
        <v-card-title style="font-size: 28px; font-weight: 500">
          Devices
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-row no-gutters>
          <v-col cols="12" sm="1"></v-col>
          <v-col cols="12" sm="5" class="pr-2">
            <v-select v-model="audioDevices" :items="selectAudioDevices" label="Audio" outlined></v-select>
          </v-col>
          <v-col cols="12" sm="5" class="pl-2">
            <v-select v-model="videoDevices" :items="selectVideoDevices" label="Video" outlined></v-select>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeDialog">
            {{ $t("button.btnrecord") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
const sign = require('jwt-encode');
const secret = 'secret';
// import { mapActions, mapState } from 'vuex'
export default {
  mounted() {
    this.getMedia()
    this.onMicVolumeChange(this.micVolume)
    // const audio = this.$refs.player
    // const constraints = {
    //   audio: true,
    //   video: false
    // }
    // navigator.mediaDevices.getUserMedia(constraints).then(media => {
    //   this.media = media
    //   audio.srcObject = media
    //   // media.active = this.clickvoice
    // })
    // this.getstatusdisconet()
    // const vm = this
    // this.intervalTime = setInterval(() => {
    //   vm.getstatusdisconet()
    // }, 10000)
  },
  data() {
    return {
      datavideo: '',
      datavideo1: '',
      qrcode: '',
      dialogU: false,
      loading: false,
      cameraLoading: false,
      cameraBlocked: false,
      selectedAudioDeviceId: null,
      selectedVideoDeviceId: null,
      microphoneCheckActive: false,
      micTestTimer: null,
      deviceLabelMap: {
        audio: {},
        video: {},
      },
      micVolume: 100,
      audioMenu: false,
      videoMenu: false,
      micTestMenu: false,
      loader: null,
      idrooms: '',
      datavideo2: 2464,
      itemsvideo: [
        'Up to 512kbps',
        'Up to 768kbps',
        'Up to 1024kbps',
        'Medium (Up to 1264kbps)',
        'Up to 1500kbps',
        'High (Up to 2464kbps)',
        'Very High (Up to 6144kbps)'
      ],
      chkSecretRoom: false,
      marker: true,
      mediaStream: null,
      jwt: require('jsonwebtoken'),
      stateVideo: false,
      stateAudio: false,
      clickvideo: false,
      clickvoice: false,
      SecretRoom: false,
      disconnect: false,
      show1: false,
      media: null,
      showHeart: false,
      user: '',
      loa: '',
      room: '',
      userData: '',
      typeroom: '',
      txtpass: '',
      cid: '',
      password: '',
      setDialogDevice: false,
      devices: null,
      videoDevices: '',
      txtLink: '',
      txtinfo: '',
      audioDevices: '',
      selectAudioDevices: [],
      selectVideoDevices: [],
      uuid_video: '',
      uuid_audio: '',
      conference_type: '',
      txtLinkidrooms: '',
      vote: '',
      onehcat: '',
      roomsuid: '',
      roomname: '',
      usermeeting_id: '',
      logo: '',
      namecompany: '',
      switchEnabled: false,
    }
  },
  created() {
    this.uuid = this.$route.query.uuid
    if (localStorage.getItem('user-token') === null) {
      this.$router.push('/')
    } else {
      this.decodejwttoken()
    }
    this.getDevice()
  },
  beforeDestroy() {
    this.stopMicrophoneCheck && this.stopMicrophoneCheck()
    this.stopStream && this.stopStream(this.media)
    this.stopMediaTracks && this.stopMediaTracks()
  },
  computed: {
    micLevelBars() {
      const breakpoint = this.$vuetify && this.$vuetify.breakpoint
      const totalBars = breakpoint && breakpoint.smAndDown ? 18 : 32
      return Array.from({ length: totalBars }, (_, index) => index)
    },
    micCanvasWidth() {
      const breakpoint = this.$vuetify && this.$vuetify.breakpoint
      if (breakpoint && breakpoint.smAndDown) {
        return 240
      }
      return 360
    },
    micVolumeLabel() {
      if (typeof this.$t === 'function') {
        const translated = this.$t('message.micVolume')
        if (translated && translated !== 'message.micVolume') {
          return translated
        }
      }
      return 'Microphone Volume'
    },
  },
  methods: {
    openDialogDevice() {
      this.setDialogDevice = true
    },
    micBarStyle(index) {
      const total = this.micLevelBars.length || 1
      const progress = total > 1 ? index / (total - 1) : 0
      const delay = (index % 10) * 0.14
      const duration = 2 + (index % 6) * 0.2
      const height = 12 + Math.sin(progress * Math.PI) * 18
      return {
        height: `${Math.max(height, 10).toFixed(0)}px`,
        animationDelay: `${delay.toFixed(2)}s`,
        animationDuration: `${duration.toFixed(2)}s`
      }
    },
    onMicVolumeChange(value) {
      const level = typeof value === 'number' ? value : this.micVolume
      const normalized = Math.min(Math.max(level / 200, 0), 1)
      this.applyMicVolumeToStream(this.mediaStream, normalized)
      this.applyMicVolumeToStream(this.media, normalized)
      const videoElement = document.getElementById('vid')
      if (videoElement) {
        videoElement.volume = normalized
      }
    },
    selectAudioDevice(option) {
      this.audioDevices = option
      this.onAudioDeviceChange()
      this.audioMenu = false
    },
    selectVideoDevice(option) {
      this.videoDevices = option
      this.onVideoDeviceChange()
      this.videoMenu = false
    },
    applyMicVolumeToStream(stream, normalizedVolume) {
      if (!stream || typeof normalizedVolume !== 'number') {
        return
      }
      const volumeValue = Math.min(Math.max(normalizedVolume, 0), 1)
      stream.getAudioTracks().forEach((track) => {
        if (typeof track.applyConstraints === 'function') {
          track
            .applyConstraints({
              advanced: [{ volume: volumeValue }],
            })
            .catch(() => {
              // Some browsers may not support the volume constraint; ignore errors silently.
            })
        }
      })
    },
    setStateAudio() {
      this.stateAudio = !this.stateAudio
    },
    setStateVideo() {
      this.stateVideo = !this.stateVideo
      this.getMedia({ preserveState: true })
    },
    decodejwttoken() {
      var token = localStorage.getItem('user-token')
      const decryptedText = this.CryptoJS.AES.decrypt(
        token,
        process.env.VUE_APP_SECRET_KEY
      )
        .toString(this.CryptoJS.enc.Utf8)
        .replace(/"/g, '')
      var data = this.jwt.decode(decryptedText)
      this.user = data.user
      // <!-- console.log(this.user) -->
      this.user_id = data.user._id
      this.getdatalobbyjoin()
      if (data.user.lastname === '') {
        this.firstname = data.user.email
        this.lastname = ''
      } else {
        this.firstname = data.user.name
        this.lastname = data.user.lastname
      }
    },
    getprofile() {
      this.axios.get(process.env.VUE_APP_API + '/api/v1/theme/getlogo/' + this.usermeeting_id).then(res => {
        // console.log('res', res.data.data)
        this.logo = res.data.data.logo.logo
        // this.avatar = res.data.data.user.profile
        this.namecompany = res.data.data.logo.name
        // if(logo === ''){
        //   if(namecompany === '')
        // }
      }).catch(err => {
        console.log('err getprofile', err)
      })
    },
    getstatusdisconet() {
      this.axios.get(process.env.VUE_APP_API + '/api/v1/room/getstatus').then(res => {
        if (res.data.status === 'Success' || res.data.status === 'Waiting Host') {
          this.disconnect = true
        } else {
          this.disconnect = false
        }
      }).catch(err => {
        this.disconnect = false
        console.log('err getstatusdisconet', err.response)
      })
    },
    async getdatalobbyjoin() {
      this.uuid = this.$route.query.uuid
      // console.log('uuid', this.uuid)
      this.axios.get(process.env.VUE_APP_API + '/api/lv1/join/check/' + this.uuid).then(async (res) => {
        // console.log('userData', res)
        if (res.data.result === 'Success') {
          this.userData = JSON.parse(this.decodeJS(res.data.data))
          // console.log('userData', this.userData)
          this.usermeeting_id = this.userData.meeting_id
          // console.log('usermeeting_id', this.usermeeting_id)
          // console.log('/api/v1/join/check/', this.dataroom)
          this.roomname = this.userData.roomname
          this.typeroom = this.userData.setting.type
          if (this.userData.loa === null) {
            this.loa = ''
          } else {
            this.loa = this.userData.loa
          }
          this.idrooms = this.uuid

          this.txtLinkidrooms = this.idrooms
          this.cid = process.env.VUE_APP_DOMAIN + '/join/?uuid=' + this.uuid
          this.txtLink = this.cid + '&openExternalBrowser=1'
          this.txtinfo = await this.copyinfo(this.cid + "&openExternalBrowser=1");
          // console.log('res Success', this.dataroom)
          this.hostName = this.userData.fullname
          //  this.qrcode =  this.userData.urlInvite
          this.qrcode = this.userData.setting.qrcode
          if (this.userData.pass_key === '123roominet!') {
            this.showpass = false
            this.password = ''
          } else {
            this.showpass = true
            this.password = this.userData.pass_key.slice(0, -6)
            this.txtpass = this.password
          }
          if (this.userData.setting.login === true && this.userData.setting.secretroom === false) {
            this.chkSecretRoom = false
          } else if (this.userData.setting.login === false && this.userData.setting.secretroom === false) {
            this.chkSecretRoom = false
          } else {
            this.chkSecretRoom = true
          }
          // this.getprofile()
        } else {
          console.log('NO Success', res.data.result)
        }
      })
        .catch(err => {
          if (err?.response?.data?.message === 'No meeting room.') {
            this.$swal(this.$t("message.nomeeting"), this.$t("message.tryagain"), "warning").then(
              res => {
                this.$router.push({ path: "/joinpage" }).catch(() => { });
              }
            );
          }
          // console.log('NO Success', err?.response?.data?.message || err.message)
        })
    },
    copypass() {
      var txtpass = document.getElementById('txtpass')
      txtpass.type = 'text'
      txtpass.select()
      txtpass.setSelectionRange(0, 99999) /* For mobile devices */
      document.execCommand('copy')
      txtpass.type = 'hidden'
      this.$swal(this.$t("loginpage.coppy"), this.$t("loginpage.password"), 'success')
    },
    copylink() {
      var txtLink = document.getElementById('txtLink')
      txtLink.type = 'text'
      txtLink.select()
      txtLink.setSelectionRange(0, 99999) /* For mobile devices */
      document.execCommand('copy')
      txtLink.type = 'hidden'
      this.$swal(this.$t("loginpage.coppy"), this.$t("roomsetting.linkmeeting"), 'success')
    },
    async copylinkinfo() {
      var txtinfo = document.getElementById("txtinfo");
      txtinfo.type = "text";
      txtinfo.select();
      txtinfo.setSelectionRange(0, 99999); /* For mobile devices */
      document.execCommand("copy");
      txtinfo.type = "hidden";
      const txt = await this.copyinfo(this.txtLink);
      navigator.clipboard.writeText(txt)
      this.$swal(
        this.$t("loginpage.coppy"),
        this.$t("roomsetting.linkmeeting"),
        "success"
      );
    },
    async copyinfo(txt) {
      try {
        const respone = await this.axios({
          method: "get",
          url: process.env.VUE_APP_API + "/api/lv1/room/getroominfo/" + this.uuid,
          headers: { Authorization: `Bearer ${localStorage.getItem("user-token")}` },
        });
        const data = JSON.parse(this.decodeJS(respone.data.data));
        const data_info = `${data.name
          } ได้เชิญคุณเข้าร่วมการประชุม\n \nหัวข้อการประชุม: ${data.topic
          } \nประเภทการประชุม: ${data.meeting_type} \nเวลา: ${this.toThaiDateString(
            new Date()
          )}\n \nลิงก์เข้าร่วมการประชุม: \n${data.url}&openExternalBrowser=1 \nไอดีห้อง: ${data.room_id} ${data.passcode === "" ? "" : "\nรหัสเข้าห้องประชุม:" + data.passcode
          }`;
        return data_info;
      } catch (error) {
        console.log(error);
        return txt;
      }
    },
    copylinkidrroms() {
      var txtLinkidrooms = document.getElementById('txtLinkidrooms')
      txtLinkidrooms.type = 'text'
      txtLinkidrooms.select()
      txtLinkidrooms.setSelectionRange(0, 99999) /* For mobile devices */
      document.execCommand('copy')
      txtLinkidrooms.type = 'hidden'
      this.$swal(this.$t("loginpage.coppy"), this.$t("roomsetting.idrooms"), 'success')
    },
    toThaiDateString(date) {
      let hour = date.getHours().toString().padStart(2, "0");
      let minutes = date.getMinutes().toString().padStart(2, "0");
      let second = date.getSeconds().toString().padStart(2, "0");
      return date.toLocaleDateString('th-TH', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
      }) +
        ` ${hour}:${minutes}:${second} น.`;
    },
    closeVideo() {
      if (this.clickvideo === false) {
        if (this.mediaStream) {
          this.mediaStream.getTracks().forEach(function (track) {
            // track.stop()
            if (track.kind === 'video') {
              track.enabled = true
            }
          })
        }
      } else {
        if (this.mediaStream) {
          this.mediaStream.getTracks().forEach(function (track) {
            // track.stop()
            if (track.kind === 'video') {
              track.enabled = false
            }
          })
        }
      }
      this.clickvideo = !this.clickvideo
    },
    closeAudio() {
      // if (this.clickvoice === false) {
      //   if (this.mediaStream) {
      //     this.mediaStream.getTracks().forEach(function (track) {
      //       // track.stop()
      //       if (track.kind === 'audio') {
      //         track.enabled = true
      //       }
      //     })
      //   }
      // } else {
      //   if (this.mediaStream) {
      //     this.mediaStream.getTracks().forEach(function (track) {
      //       // track.stop()
      //       if (track.kind === 'audio') {
      //         track.enabled = false
      //       }
      //     })
      //   }
      // }
      this.clickvoice = !this.clickvoice
    },
    getMedia(options = {}) {
      const { preserveState = false } = options
      this.cameraLoading = true
      this.cameraBlocked = false
      if (!preserveState) {
        // this.clickvoice = true
        // this.clickvideo = true
        this.showHeart = false
      }
      const videoPlaysInLine = document.getElementById('vid')
      if (videoPlaysInLine) {
        videoPlaysInLine.setAttribute('playsinline', true)
      }
      const audioConstraint = this.selectedAudioDeviceId
        ? { deviceId: { exact: this.selectedAudioDeviceId } }
        : true
      const videoConstraint = { width: 1280, height: 650 }
      if (this.selectedVideoDeviceId) {
        videoConstraint.deviceId = { exact: this.selectedVideoDeviceId }
      }
      this.stopMediaTracks()
      const constraints = {
        audio: audioConstraint,
        video: videoConstraint,
      }
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((mediaStream) => {
          const videoElement = document.getElementById('vid')
          this.mediaStream = mediaStream
          this.cameraBlocked = false
          mediaStream.getAudioTracks().forEach((track) => {
            track.enabled = this.clickvoice
          })
          mediaStream.getVideoTracks().forEach((track) => {
            track.enabled = this.clickvideo
          })
          this.applyMicVolumeToStream(mediaStream, this.micVolume / 200)
          if (videoElement) {
            videoElement.srcObject = mediaStream
            videoElement.volume = Math.min(Math.max(this.micVolume / 200, 0), 1)
            const attemptPlay = videoElement.play()
            if (attemptPlay && typeof attemptPlay.finally === 'function') {
              attemptPlay.finally(() => {
                this.cameraLoading = false
              })
            } else {
              this.cameraLoading = false
            }
            videoElement.onplaying = () => {
              this.cameraLoading = false
            }
          } else {
            this.cameraLoading = false
          }
          this.getAudioWave()
        })
        .catch((err) => {
          console.log(err.name + ': ' + err.message)
          this.cameraBlocked =
            err &&
            (err.name === 'NotAllowedError' || err.name === 'SecurityError' || err.name === 'PermissionDeniedError')
          if (this.cameraBlocked) {
            this.clickvideo = false
            if (!this.clickvoice) {
              this.showHeart = false
            }
          }
          this.cameraLoading = false
        })
    },
    // getMedia(constraints) {
    //   const vm = this
    //   navigator.mediaDevices
    //     .getUserMedia(constraints)
    //     .then((mediaStream) => {
    //       // console.log('mediaStream', mediaStream)
    //       const video = document.querySelector('video')
    //       vm.mediaStream = mediaStream
    //       video.srcObject = mediaStream
    //       video.onloadedmetadata = function (e) {
    //         video.play()
    //       }
    //       if (this.stateVideo === true) {
    //         video.srcObject.getTracks().forEach(function (track) {
    //           track.stop()
    //         })
    //         vm.mediaStream.getTracks().forEach(function (track) {
    //           track.stop()
    //         })
    //       }
    //     })
    //     .catch(function (err) {
    //       console.log(err.name + ': ' + err.message)
    //     })
    // },
    getAudioWave(forceShow = false) {
      const constraints = {
        audio: this.selectedAudioDeviceId
          ? { deviceId: { exact: this.selectedAudioDeviceId } }
          : true,
        video: false,
      }
      return navigator.mediaDevices
        .getUserMedia(constraints)
        .then((media) => {
          this.stopStream(this.media)
          this.media = media
          this.applyMicVolumeToStream(media, this.micVolume / 200)
          if (forceShow) {
            this.showHeart = true
          }
          return media
        })
        .catch((err) => {
          console.log('getAudioWave', err.name + ': ' + err.message)
          if (forceShow) {
            this.microphoneCheckActive = false
          }
        })
    },
    stopStream(stream) {
      if (!stream) {
        return
      }
      stream.getTracks().forEach((track) => track.stop())
    },
    stopMediaTracks(kinds = null) {
      if (!this.mediaStream) {
        return
      }
      this.mediaStream.getTracks().forEach((track) => {
        if (!kinds || kinds.includes(track.kind)) {
          track.stop()
        }
      })
      if (!kinds) {
        this.mediaStream = null
      }
    },
    resolveDeviceId(kind, label) {
      if (!label || !this.devices) {
        return null
      }
      const map = kind === 'audioinput' ? this.deviceLabelMap.audio : this.deviceLabelMap.video
      if (map && map[label]) {
        return map[label]
      }
      const match = this.devices.find(
        (device) => device.kind === kind && device.label === label
      )
      return match ? match.deviceId : null
    },
    syncSelectedDeviceIds() {
      this.selectedAudioDeviceId = this.resolveDeviceId('audioinput', this.audioDevices)
      this.selectedVideoDeviceId = this.resolveDeviceId('videoinput', this.videoDevices)
      this.uuid_audio = this.selectedAudioDeviceId || ''
      this.uuid_video = this.selectedVideoDeviceId || ''
    },
    onAudioDeviceChange() {
      this.syncSelectedDeviceIds()
      this.restartMediaStream()
      this.getAudioWave()
    },
    onVideoDeviceChange() {
      this.syncSelectedDeviceIds()
      this.restartMediaStream()
    },
    restartMediaStream() {
      if (this.cameraBlocked) {
        this.cameraBlocked = false
      }
      this.getMedia({ preserveState: true })
    },
    updateDeviceCollections(audioDevices, videoDevices) {
      const audioMap = {}
      const videoMap = {}
      this.selectAudioDevices = audioDevices.map((device, index) => {
        const label = device.label || this.$t('message.micFallback', { index: index + 1 })
        audioMap[label] = device.deviceId
        return label
      })
      this.selectVideoDevices = videoDevices.map((device, index) => {
        const label = device.label || this.$t('message.camFallback', { index: index + 1 })
        videoMap[label] = device.deviceId
        return label
      })
      this.deviceLabelMap.audio = audioMap
      this.deviceLabelMap.video = videoMap
      if (!this.audioDevices || !audioMap[this.audioDevices]) {
        this.audioDevices = this.selectAudioDevices[0] || ''
      }
      if (!this.videoDevices || !videoMap[this.videoDevices]) {
        this.videoDevices = this.selectVideoDevices[0] || ''
      }
      this.syncSelectedDeviceIds()
    },
    checkMicrophone() {
      if (this.showHeart === false) {
        this.getAudioWave()
        if (this.mediaStream) {
          this.mediaStream.getTracks().forEach(function (track) {
            if (track.kind === 'audio') {
              track.enabled = true
            }
          })
        }
        this.showHeart = true
      } else {
        this.mediaStream.getTracks().forEach(function (track) {
          if (track.kind === 'audio') {
            track.enabled = false
          }
        })
        this.showHeart = false
      }
    },
    stopMicrophoneCheck() {
      if (this.micTestTimer) {
        clearTimeout(this.micTestTimer)
        this.micTestTimer = null
      }
      this.microphoneCheckActive = false
      if (!this.clickvoice) {
        this.showHeart = false
      }
    },
    closeDialog() {
      this.syncSelectedDeviceIds()
      this.restartMediaStream()
      this.getAudioWave()
      this.setDialogDevice = false
    },
    async getDevice() {
      await navigator.mediaDevices.enumerateDevices().then((devices) => {
        this.devices = devices
        const audioDevices = devices.filter(
          (device) => device.kind === 'audioinput'
        )
        const videoDevices = devices.filter(
          (device) => device.kind === 'videoinput'
        )
        this.updateDeviceCollections(audioDevices, videoDevices)
      })
    },
    download() {
      const linkSource = 'data:png/jpg;base64,' + this.qrcode
      const downloadLink = document.createElement("a")
      document.body.appendChild(downloadLink)
      downloadLink.href = linkSource
      downloadLink.download = 'QR_CODE' + this.roomname + '.jpg'
      downloadLink.click()
    },
    checktypestart() {
      this.refrestoken()
      if (this.datavideo === 'Up to 512kbps') {
        this.datavideo1 = '512'
        this.datavideo2 = 512
      } else if (this.datavideo === 'Up to 768kbps') {
        this.datavideo1 = '768'
        this.datavideo2 = 768
      } else if (this.datavideo === 'Up to 1024kbps') {
        this.datavideo1 = '1024'
        this.datavideo2 = 1024
      } else if (this.datavideo === 'Medium (Up to 1264kbps)') {
        this.datavideo1 = '1264'
        this.datavideo2 = 1264
      } else if (this.datavideo === 'Up to 1500kbps') {
        this.datavideo1 = '1500'
        this.datavideo2 = 1500
      } else if (this.datavideo === '' || this.datavideo === 'High (Up to 2464kbps)') {
        this.datavideo1 = '2464'
        this.datavideo2 = 2464
      } else if (this.datavideo === 'Very High (Up to 6144kbps)') {
        this.datavideo1 = '6144'
        this.datavideo2 = 6144
      }
      // console.log('checktypestart', this.userData.setting.type)
      if (this.userData.setting.type === 'onertc') {
        // console.log('webapp')
        this.getDeviceCamera()
      } else {
        this.startRoomapp()
        // console.log('webrtc')
      }
    },
    async startRoomapp() {
      await this.axios.post(process.env.VUE_APP_API + '/api/lv1/room/start', {
        meeting_id: this.userData.meeting_id,
        devices: {
          video_mute: !this.clickvideo,
          audio_mute: !this.clickvoice,
          video_bandwidth: this.datavideo2,
          secretroom: this.userData.setting.secretroom,
          meetingLock: this.userData.setting.meetingLock,
          login: this.userData.setting.login
        }
      }).then(res => {
        // console.log('AAAAA', res)
        var tokenlivekit = this.decodeJS(res.data.data)
        // console.log('tokenlivekit', tokenlivekit)
        const jwt = sign({ token: res.data.data, user_id: this.userData.oneid, useBgDefault: this.switchEnabled }, secret);
        // console.log('jwt', jwt)
        const deeplink = process.env.VUE_APP_WEBRTC + '/conference/host/' + jwt;
        window.location.href = deeplink;
      })
    },
    async refrestoken() {
      var token = localStorage.getItem('user-token')
      await this.axios.get(process.env.VUE_APP_API + '/api/lv1/auth/refreshtoken',
        {
          headers: {
            Authorization: "bearer " + localStorage.getItem('user-token'),
          },
        }
      ).then(res => {
        // console.log('sssss', res)
      }).catch(err => {
        this.$swal(this.$t("message.Sessiontimeout"), '', 'warning').then(result => {
          localStorage.clear()
          localStorage.setItem("lang", "th")
          window.open('/', '_self')
        })
      })
    },
    async getDeviceCamera() {
      await navigator.mediaDevices.enumerateDevices().then((devices) => {
        this.devices = devices
        const audioDevices = devices.filter(
          (device) => device.kind === 'audioinput'
        )
        const videoDevices = devices.filter(
          (device) => device.kind === 'videoinput'
        )
        this.updateDeviceCollections(audioDevices, videoDevices)
      }).catch(this.startmeet())
      this.startmeet()
      // this.startRoomrtc()
    },
    async startmeet() {
      // console.log('AAAAA1', this.userData.meeting_id)
      await this.axios.post(process.env.VUE_APP_API + '/api/lv1/room/start/', {
        meeting_id: this.userData.meeting_id,
        devices: {
          video_mute: !this.clickvideo,
          audio_mute: !this.clickvoice,
          video_bandwidth: this.datavideo2,
        }
      }).then(res => {
        // console.log('AAAAA', res.data.data.token)
        var tokenlivekit = this.decodeJS(res.data.data.token)
        // console.log('tokenlivekit', tokenlivekit)
      })
    },
    gomanage() {
      window.open('/manage', '_self')
    },
    decodeJS(data) {
      try {
        var bytes = this.CryptoJS.AES.decrypt(
          data,
          process.env.VUE_APP_SECRET_KEY
        )
        var decryptedData = JSON.parse(bytes.toString(this.CryptoJS.enc.Utf8))
        return decryptedData
      } catch (error) {
        console.log('>>>>>>>>', error)
        return error
      }
    },
    async endMeeting() {
      this.loading = true
      await this.axios
        .post(process.env.VUE_APP_API + '/api/lv1/room/close/' + this.usermeeting_id)
        .then((result) => {
          // const data = result.data
          // console.log(result)
          if (result.data.result === 'Success') {
            this.loading = false
            this.$swal
              .fire({
                title: this.$t("button.btncloserooms"),
                text: '',
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#04449F',
                confirmButtonText: this.$t("button.btnACCEPT"),
                cancelButtonColor: '#D63A3A',
                cancelButtonText: this.$t("button.btncancel")
              }).then((res) => {
                if (res.isConfirmed === true) {
                  // this.$router.push('/')
                  this.cloesreport(this.usermeeting_id)
                  // window.open('/manage', '_self')
                } else {
                  // console.log('Cancel')
                  // this.$router.push('/')
                  window.open('/', '_self')
                }
              })
          }
          // this.genreport(data.meeting_id)
        })
        .catch((err) => {
          console.log('error', err)
        })
    },
    cloesreport(meeting_id) {
      this.axios.post(process.env.VUE_APP_API + '/api/lv1/report/genreport/' + meeting_id)
        .then((result) => {
          // console.log(result)
          if (result.data.result === 'Success') {
            window.open('/manage', '_self')
          } else {
            this.$swal('', result.data.message, 'warning').then(res => {
              window.open('/', '_self')
            })
          }
        }).catch((err) => {
          console.log('error', err)
        })
    },
    closeOneChat(tokenclose) {
      // localStorage.setItem('user-token', tokenclose)
      this.axios.delete(process.env.VUE_APP_API_ONECHAT + '/backend/api/v1/rooms',
        {
          headers: { Authorization: `Bearer ${this.userData.setting.onechat.access_onechat}` }
        }
      )
        .then((result) => {
          const data = result.data
          this.loading = false
          this.$swal
            .fire({
              title: this.$t("button.btncloserooms"),
              text: '',
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: '#04449F',
              confirmButtonText: this.$t("button.btnACCEPT"),
              cancelButtonColor: '#D63A3A',
              cancelButtonText: this.$t("button.btncancel")
            }).then((res) => {
              if (res.isConfirmed === true) {
                // this.$router.push('/')
                window.open('/manage', '_self')
              } else {
                // console.log('Cancel')
                // this.$router.push('/')
                window.open('/', '_self')
              }
            })
        })
        .catch((err) => {
          console.log('error', err)
          this.$router.push('/')
        })
    }
  },
}
</script>
<style scoped lang="css">
@import url("https://fonts.googleapis.com/css?family=Noto+Sans:400,700,400italic,700italic&subset=latin,latin-ext");
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@100;200&display=swap");

.toggle-switch-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
}

.toggle-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  line-height: 0;
  margin-bottom: 0;
}

.toggle-switch input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-track {
  display: inline-flex;
  align-items: center;
  width: 64px;
  height: 30px;
  border-radius: 30px;
  background-color: #ccd0de;
  position: relative;
  transition: background-color 0.3s ease;
  box-shadow: inset 0 1px 4px rgba(0, 0, 0, 0.1);
}

.toggle-switch input:checked + .toggle-track {
  background-color: #3d85c6;
}

.toggle-thumb {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: white;
  position: absolute;
  top: 4px;
  left: 4px;
  transition: transform 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  z-index: 1;
}

.toggle-switch input:checked + .toggle-track .toggle-thumb {
  transform: translateX(34px);
}

.toggle-label-on,
.toggle-label-off {
  position: absolute;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.5px;
  pointer-events: none;
  user-select: none;
  transition: opacity 0.2s;
}

.toggle-label-on {
  color: white;
  left: 14px;
  opacity: 0;
}

.toggle-label-off {
  color: #9098b1;
  right: 12px;
  opacity: 1;
}

.toggle-switch input:checked + .toggle-track .toggle-label-on {
  opacity: 1;
}

.toggle-switch input:checked + .toggle-track .toggle-label-off {
  opacity: 0;
}

.toggle-text-label {
  font-family: 'Kanit', sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #9098b1;
  transition: color 0.2s;
}

.toggle-text-label.is-on {
  color: #3d85c6;
}

body {
  font-family: "Noto Sans", sans-serif;
  font-weight: 400;
  /* font-weight: 700; */
}

.video-lobby {
  position: relative;
  overflow: hidden;
}

.video-muted {
  filter: grayscale(100%);
  opacity: 0.35;
}

.video-off-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
  color: #ffffff;
  text-align: center;
  pointer-events: none;
  border-radius: 20px;
  z-index: 10;
}

.video-off-icon {
  font-size: 48px;
  margin-bottom: 4px;
}

.video-off-text {
  font-family: "Kanit", sans-serif;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.video-permission-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: calc(20px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  text-align: center;
  pointer-events: none;
  border-radius: 20px;
  z-index: 15;
}

.video-permission-icon {
  font-size: 52px;
  margin-bottom: 6px;
}

.video-permission-text {
  font-family: "Kanit", sans-serif;
  font-weight: 600;
  letter-spacing: 0.4px;
  max-width: 80%;
}

.video-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: calc(20px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
  color: #ffffff;
  text-align: center;
  border-radius: 20px;
  z-index: 20;
  pointer-events: none;
}

.video-loading-text {
  margin-top: 12px;
  font-family: "Kanit", sans-serif;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.video-button {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  transform: none;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 0 24px;
  z-index: 30;
}

.video-action-btn {
  width: 56px;
  height: 56px;
  background: rgba(20, 23, 35, 0.72) !important;
  color: rgba(255, 255, 255, 0.92) !important;
  border: 1px solid rgba(88, 101, 242, 0.18);
  box-shadow: 0 14px 26px rgba(8, 10, 18, 0.45);
  transition: background 0.2s ease, transform 0.2s ease;
}

.video-action-btn ::v-deep .v-icon {
  font-size: 26px;
}

.video-action-btn:hover {
  background: rgba(35, 39, 55, 0.92) !important;
  transform: translateY(-2px);
}

/* @media (max-width: 600px) {
  .video-off-overlay,
  .video-permission-overlay,
  .video-loading-overlay {
    bottom: calc(44px + 12px);
    border-bottom-left-radius: 18px;
    border-bottom-right-radius: 18px;
  }

  .video-button {
    position: absolute;
    bottom: 12px;
    left: 0;
    right: 0;
    transform: none;
    width: 100%;
    padding: 10px 12px;
    background: rgba(33, 36, 48, 0.95);
    border-radius: 18px;
    gap: 10px;
    justify-content: space-evenly;
    box-shadow: 0 12px 28px rgba(10, 12, 20, 0.42);
  }

  .video-action-btn {
    flex: 1 1 44px;
    width: auto;
    min-width: 40px;
    max-width: 52px;
    height: 44px;
    box-shadow: 0 8px 16px rgba(8, 10, 18, 0.35);
  }
  .video-action-btn ::v-deep .v-icon {
    font-size: 22px;
  }
} */

.device-dropdown-card {
  background: rgba(17, 19, 28, 0.95);
  border-radius: 16px;
  padding: 12px 0;
  color: #ffffff;
  box-shadow: 0 18px 34px rgba(9, 11, 18, 0.6);
  border: 1px solid rgba(88, 101, 242, 0.12);
}

.device-dropdown-header {
  display: flex;
  align-items: center;
  padding: 0 20px 8px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.35px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.8);
}

.device-dropdown-list {
  max-height: 220px;
  overflow-y: auto;
}

.device-dropdown-list .v-list-item {
  min-height: 44px;
}

.device-dropdown-list .v-list-item.is-active {
  background: rgba(88, 101, 242, 0.16);
}

.device-dropdown-list .v-list-item-title {
  color: rgba(255, 255, 255, 0.92);
  font-weight: 500;
}

.device-dropdown-list ::v-deep .v-list-item__icon {
  margin-right: 12px;
}

.mic-test-dropdown-card {
  background: rgba(17, 19, 28, 0.95);
  border-radius: 16px;
  padding: 16px 18px;
  color: #ffffff;
  box-shadow: 0 20px 36px rgba(9, 11, 18, 0.6);
  border: 1px solid rgba(88, 101, 242, 0.12);
}

.mic-test-dropdown-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.mic-test-dropdown-title {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.mic-test-dropdown-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.68);
  line-height: 1.5;
  margin-top: 2px;
}

.mic-test-dropdown-body {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
}

.mic-volume-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
}

.mic-volume-value {
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
}

.mic-volume-slider {
  width: 100%;
  max-width: 260px;
}

.mic-volume-slider ::v-deep .v-slider__track-container {
  height: 4px;
}

.mic-volume-slider ::v-deep .v-slider__thumb {
  box-shadow: 0 3px 10px rgba(88, 101, 242, 0.45);
}

.mic-test-dropdown-actions {
  margin-top: 4px;
}

.mic-visualizer-popup {
  width: 100%;
  min-height: 88px;
  padding: 12px;
  flex: 1 1 auto;
}

.mic-visualizer-popup .mic-visualizer-live ::v-deep canvas {
  height: 34px !important;
}

.mic-volume-label {
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.72);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.av-media-style {
  width: 100%;
  opacity: 0.9;
}

.mic-test-button {
  padding: 0 20px;
  font-weight: 600;
  letter-spacing: 0.2px;
  text-transform: none;
}

.mic-test-button.is-active {
  background-color: #f44336 !important;
  border-color: #f44336 !important;
  color: #ffffff !important;
}

.mic-visualizer {
  flex: 1 1 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 8px 14px;
  border-radius: 12px;
  background: rgba(31, 35, 51, 0.88);
  border: 1px solid rgba(88, 101, 242, 0.2);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.02);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.mic-visualizer.is-active {
  border-color: rgba(88, 101, 242, 0.75);
  box-shadow: 0 0 22px rgba(88, 101, 242, 0.32);
  background: rgba(40, 44, 66, 0.95);
}

.mic-visualizer-live {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 32px;
}

.mic-visualizer-live audio {
  display: none;
}

.mic-visualizer-live ::v-deep canvas {
  width: 100% !important;
  height: 32px !important;
}

.mic-visualizer-idle {
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 4px;
  min-height: 32px;
  height: 32px;
}

.mic-visualizer-idle-bar {
  width: 6px;
  flex: 0 0 6px;
  border-radius: 3px;
  background: linear-gradient(180deg, rgba(136, 145, 189, 0.5) 0%, rgba(78, 84, 112, 0.45) 100%);
  opacity: 0.7;
  animation-name: micIdlePulse;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  transform-origin: bottom;
}

.mic-visualizer.is-active .mic-visualizer-idle-bar {
  background: rgba(88, 101, 242, 0.85);
}

@keyframes micIdlePulse {

  0%,
  100% {
    transform: scaleY(0.5);
    opacity: 0.4;
  }

  50% {
    transform: scaleY(1);
    opacity: 0.9;
  }
}
</style>
